import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MergeRecordsConfirm from '../../components/modal/MergeRecordsConfirm';
import { mergeReferrals, getMergePreview } from '../../actions/records';

class MergeRecordsConfirmDialog extends Component {
  render() {
    return (
      <div>
        <MergeRecordsConfirm
          {...this.props}
        />
      </div>
    );
  }
}

MergeRecordsConfirmDialog.propTypes = {
  mergeReferrals: PropTypes.func.isRequired,
  getMergePreview: PropTypes.func.isRequired,
};

export default connect(null, {
  mergeReferrals,
  getMergePreview,
})(MergeRecordsConfirmDialog);
